const addAnalysisFormTitle = {
    addFlowmeter: 'addFlowmeter',
    editAnalysis: 'editAnalysis',
    addProductLevel: 'addProductLevel',
    addFuelConsumption: 'addFuelConsumption',
};

export default addAnalysisFormTitle;
